<div class="sidenav-header">
  <div class="sidenav-header-logo">
    @if (newsfeedEnabled$ | async) {
    <a routerLink="/" (click)="onClickClose()"> <bau365-shell-logo-dark></bau365-shell-logo-dark> </a>
    } @else {
    <bau365-shell-logo-dark></bau365-shell-logo-dark>
    }
  </div>
  <a class="sidenav-header-close" (click)="onClickClose()">
    <mat-icon>close</mat-icon>
  </a>
</div>
